<template>
  <div class="wrap">
    <slot />
  </div>
</template>

<style lang="scss">
  @use '@experience/shared/dist/assets/adaptivity';

  :host {
    --wrap-max-width: 1260px;
    --wrap-min-width: 950px;
    --wrap-offset: 20px;

    @include adaptivity.mobile {
      --wrap-max-width: 100%;
      --wrap-min-width: 100%;
    }
  }
</style>

<style lang="scss" scoped>
  @use '@experience/shared/dist/assets/adaptivity';

  .wrap {
    width: 100%;
    max-width: var(--wrap-max-width);
    margin: 0 auto;
    padding: 0 var(--wrap-offset);

    @include adaptivity.tablet {
      box-sizing: border-box;
    }
  }
</style>
